import { GlobalHelper } from "../../../indexImports"
import ExternalShippingMethod from "../ExternalShippingMethod"
import Fee from "../Fee"

export const CreatedExternalShippingMethodsMapping = (feeDto) => {
    const shippingMethodsMapping = {}
    for (const integrationKey of GetIntegrationsSupportingExternalShippingMethod()) {
        if (!shippingMethodsMapping[integrationKey]) {
            shippingMethodsMapping[integrationKey] = null
        }
    }
    if (!feeDto) {
        return shippingMethodsMapping
    }

    const fee = new Fee(feeDto)
    const externalShippingMethods = fee.getExternalShippingMethods()

    for (const shippingMethod of externalShippingMethods) {
        shippingMethodsMapping[shippingMethod.getIntegrationKey()] = formatShippingMethod(shippingMethod)
    }

    return shippingMethodsMapping
}

export const GetIntegrationsSupportingExternalShippingMethod = () => {
    const integrations = [] as string[]
    if (GlobalHelper.hasLightspeedEcomIntegration()) {
        integrations.push("ls-ecom")
    }

    if (GlobalHelper.hasLightspeedEcomOmniIntegration()) {
        integrations.push("ls-ecom-omni")
    }

    if (GlobalHelper.hasLightspeedEcomOmniIntegration()) {
        integrations.push("ls-ecom-omni-na")
    }
    return integrations
}

const formatShippingMethod = (shippingMethod: ExternalShippingMethod) => {
    return {
        externalId: shippingMethod.getId(),
        title: shippingMethod.getTitle(),
        integrationKey: shippingMethod.getIntegrationKey(),
    }
}


// WEBPACK FOOTER //
// ./src/state/fee/helpers/FeeExternalShippingMappingHelper.ts